import React from "react";

export default function CopyIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M9 9.75A2.25 2.25 0 0 1 11.25 7.5h6A2.25 2.25 0 0 1 19.5 9.75v8.25a2.25 2.25 0 0 1-2.25 2.25h-6A2.25 2.25 0 0 1 9 18V9.75Z"
        stroke="currentColor"
        strokeWidth="1.7"
      />
      <path
        d="M15 7.5V6A2.25 2.25 0 0 0 12.75 3.75h-6A2.25 2.25 0 0 0 4.5 6v8.25A2.25 2.25 0 0 0 6.75 16.5H9"
        stroke="currentColor"
        strokeWidth="1.7"
      />
    </svg>
  );
}
